import { select, put } from 'redux-saga/effects'

import Zoid from 'common/modules/zoid'
import Lifecycle from 'common/modules/lifecycle'

export default function* watchPlanPurchased() {
    const { releaseArticle } = yield select(Zoid.selectors.getXprops)
    yield put(Lifecycle.creators.paymentPaid())
    yield releaseArticle()
}
